export const rem = pt => (pt / 16) + 'rem';
export const px = pt => (pt * 0.75) + 'px';